import { render, staticRenderFns } from "./pos-LessSales.vue?vue&type=template&id=afc0ec6a"
import script from "./pos-LessSales.vue?vue&type=script&lang=js"
export * from "./pos-LessSales.vue?vue&type=script&lang=js"
import style0 from "./pos-LessSales.vue?vue&type=style&index=0&id=afc0ec6a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports